import React from 'react';


class GameDetailsInnerSummary extends React.Component {
  paymentInfo = () => {
    if (this.props.game.isRandomRelations || this.props.game.isKingOfTheHill)
      return;
  }

  Trener = () => {
    if (this.props.game.isTraining) {
      return (
        <li className="game__description-item game__description-item--coach">
          <div className="game__description-item-label">Тренер</div>
          <div className="game__description-item-value">{this.props.game.coach}</div>
        </li>
      )
    } else {
      return;
    }
  }

  Status = () => {
    const { eventType, status } = this.props.game;
    let statusText;

    if (this.props.game.isTraining && status === 'CANCELLED') {
      statusText = 'Отменена';
    } else if (status === 'CANCELLED') {
      statusText = 'Отменен';
    }

    if (statusText) {
      return (
        <li className="game__description-item game__description-item--status">
          <div className="game__description-item-label">Статус</div>
          <div className="game__description-item-value">
            <font color="red">{statusText}</font>
          </div>
        </li>
      );
    }

    return null;
  }

  SEX_LABELS = { MEN: "Мужчины", WOMEN: "Девушки", MIXT: "Любой" };

  sex_label = () => {
    if (this.props.game.isMenLimited) return this.SEX_LABELS.MEN;
    if (this.props.game.isWomenLimited) return this.SEX_LABELS.WOMEN;
    return this.SEX_LABELS.MIXT;
  }

  render() {
    return (
      <div className="col-sm-6">
        <ul className="game__description">
          <li className="game__description-item game__description-item--time">
            <div className="game__description-item-label">Время</div>
            <div className="game__description-item-value">{this.props.game.timeFrame}</div>
          </li>
          {this.Status()}
          <li className="game__description-item game__description-item--place">
            <div className="game__description-item-label">Место</div>
            <div className="game__description-item-value">{this.props.game.playingField}</div>
          </li>
          <li className="game__description-item game__description-item--sex">
            <div className="game__description-item-label">Пол</div>
            <div className="game__description-item-value">{this.sex_label()}</div>
          </li>
          <li className="game__description-item game__description-item--level">
            <div className="game__description-item-label">Уровень</div>
            <div className="game__description-item-value">{this.props.game.skill}</div>
          </li>
          {this.Trener()}
          <li className="game__description-item game__description-item--price">
            <div className="game__description-item-label">Стоимость</div>
            <div className="game__description-item-value">{this.props.game.price}</div>
          </li>
          {this.paymentInfo()}
        </ul>
      </div>
    )
  }
}

export default GameDetailsInnerSummary;
